var map = {
	"./aiSecurity/en.json": [
		4117,
		62
	],
	"./dataLeakage/en.json": [
		4118,
		65
	],
	"./ppd/en.json": [
		4119,
		68
	],
	"./ransomware/en.json": [
		4120,
		71
	],
	"./socialMedia/en.json": [
		4121,
		74
	],
	"./whatsApp/en.json": [
		4122,
		77
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1336;
module.exports = webpackAsyncContext;